import { ButtonProps } from '@mui/material';
import { useSwitchNetwork } from 'shared/hooks';
import { SwitchIcon } from 'shared/ui/Icon';

import { LoadingButton } from '../loading-button';

interface SwitchNetworkButtonProps {
  onSuccess?: () => void;
  onError?: () => void;
  operationText?: string;
  loading?: boolean;
  chainId: number;
}

export const SwitchNetworkButton = ({
  onSuccess,
  onError,
  operationText = 'Switch network',
  loading,
  chainId,
  sx,
  ...props
}: SwitchNetworkButtonProps & Omit<ButtonProps, 'onError'>) => {
  const { switchAsync, isSwitching } = useSwitchNetwork(onSuccess, onError);

  const isLoading = isSwitching || !!loading;

  return (
    <LoadingButton
      startIcon={<SwitchIcon />}
      disabled={isLoading}
      isLoading={isLoading}
      fullWidth
      onClick={() => switchAsync(chainId.toString())}
      {...props}
      sx={{
        ...(!operationText && {
          '.MuiButton-startIcon': {
            margin: 0,
          },
        }),
        ...sx,
      }}
    >
      {operationText}
    </LoadingButton>
  );
};
